















































































































































































































































































































import {
  computed,
  defineComponent,
  onMounted,
  ref,
  useFetch,
  useRoute,
  useRouter,
} from "@nuxtjs/composition-api";
import { copyCode, getLabelColorBySku } from "~/helpers";
import { Order, OrderInfo, OrderItem, useUiNotification } from "~/composables";
import useMakeOrder from "~/modules/checkout/composables/useMakeOrder";
import { useUser } from "~/modules/customer/composables/useUser";
import {
  getVariantImage,
  getVariantName,
  getUrlQuery,
  getBgColorValue,
  getColorLabel,
  getSizeLabel,
  getPrice,
} from "~/modules/checkout/helpers";

export default defineComponent({
  name: "OderInfo",
  components: {},
  props: {
    status: {
      type: String,
      default: null,
    },
  },
  setup(props, { emit }) {
    const route = useRoute();
    const router = useRouter();
    const { send: sendNotification } = useUiNotification();
    const { getOrderData, loading } = useMakeOrder();

    const { isAuthenticated } = useUser();

    const productConfiguration = ref(route.value.query);
    const incrementId = productConfiguration.value.increment_id
      ? (productConfiguration.value.increment_id as string).split("-")[0]
      : "";

    const paymentMethod = productConfiguration.value.method.toString() || "";
    const phoneNumber =
      productConfiguration.value.phone_number.toString() || "";
    const orderData = ref<Order>(null);
    const orderItems = ref<OrderItem[]>(null);
    const orderInfo = ref<OrderInfo>(null);

    useFetch(async () => {
      orderData.value = await getOrderData(incrementId, phoneNumber);
      orderItems.value = orderData.value?.order_items || [];
      orderInfo.value = orderData.value?.order_info || null;
    });

    const getPercent = (originalPrice: number, price: number) => {
      return 100 - Math.round((price / originalPrice) * 100);
    };

    const configSku = (sku: string) => {
      return sku.split("-");
    };

    const totalItems = computed(() => {
      return orderItems.value?.reduce((total, item) => {
        if (item?.qty_ordered && item?.qty_ordered > 0) {
          return total + item?.qty_ordered;
        }
        return total;
      }, 0);
    });

    const isMore = ref(false);

    const handleCopyCode = (code: string) => {
      copyCode(code);
      let message = `Bạn đã copy mã ${code}`;
      sendNotification({
        id: Symbol("copy_text_success"),
        message: message,
        type: "success",
        icon: "check",
        persist: false,
        title: message,
      });
    };

    const payment = () => {
      const price = orderInfo.value?.grand_total || 0;
      emit("payment", price);
    };

    const isChangePaymentMethod = computed(() => {
      return (
        isAuthenticated.value &&
        (props.status === "change" ||
          props.status === "cancel" ||
          props.status === "failed")
      );
    });

    const isPaymentAgain = computed(() => {
      return (
        props.status === "change" ||
        props.status === "failed" ||
        props.status === "cancel"
      );
    });

    const changePaymentMethod = () => {
      emit("changePaymentMethod");
    };

    const orderTracking = () => {
      emit("orderTracking");
    };

    const comebackToShopping = () => {
      window.location.href = "/";
    };

    return {
      incrementId,
      paymentMethod,
      handleCopyCode,
      isMore,
      payment,
      orderTracking,
      comebackToShopping,
      isPaymentAgain,
      isChangePaymentMethod,
      changePaymentMethod,
      orderItems,
      orderInfo,
      getPercent,
      configSku,
      getVariantImage,
      getVariantName,
      getUrlQuery,
      getBgColorValue,
      getColorLabel,
      getSizeLabel,
      getPrice,
      totalItems,
      getLabelColorBySku,
    };
  },
});
